import { render, staticRenderFns } from "./PrescriptionPresetLoading.vue?vue&type=template&id=12001590&scoped=true"
import script from "./PrescriptionPresetLoading.vue?vue&type=script&lang=js"
export * from "./PrescriptionPresetLoading.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionPresetLoading.vue?vue&type=style&index=0&id=12001590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12001590",
  null
  
)

export default component.exports